import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { Ticker } from '../../Ticker';
import style from './ParallaxGeneralTemplate.css';
import { MortgageAnnotations } from '../../MortgageAnnotations';
import { getCompleteSizes } from '@cian/adfox-component';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BACKGROUND_MAX_HEIGHT = 740;
export var ParallaxGeneralTemplate = /*#__PURE__*/function (_React$Component) {
  function ParallaxGeneralTemplate(props) {
    var _this;
    _classCallCheck(this, ParallaxGeneralTemplate);
    _this = _callSuper(this, ParallaxGeneralTemplate, [props]);
    _defineProperty(_this, "container", null);
    _defineProperty(_this, "animatedBg", null);
    _defineProperty(_this, "topPosition", void 0);
    _defineProperty(_this, "bottomPosition", void 0);
    _defineProperty(_this, "containerHeight", void 0);
    _defineProperty(_this, "scrollHandler", void 0);
    _defineProperty(_this, "resizeHandler", void 0);
    return _this;
  }
  _inherits(ParallaxGeneralTemplate, _React$Component);
  return _createClass(ParallaxGeneralTemplate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.container) {
        var shouldChange = false;
        this.containerHeight = this.container.offsetHeight;
        var scrollHandler = function scrollHandler() {
          if (!shouldChange) {
            return;
          }
          shouldChange = false;
          if (window.scrollY > _this2.topPosition && window.scrollY < _this2.bottomPosition && _this2.animatedBg) {
            var bgOffset = (window.scrollY - _this2.topPosition) / (window.innerHeight + BACKGROUND_MAX_HEIGHT);
            var translate = bgOffset * (_this2.containerHeight - BACKGROUND_MAX_HEIGHT);
            _this2.animatedBg.style.transform = "translateY(".concat(Math.round(translate), "px)");
          }
        };
        var img = new Image();
        this.scrollHandler = function () {
          shouldChange = true;
          requestAnimationFrame(scrollHandler);
        };
        this.resizeHandler = function () {
          _this2.getParams();
          requestAnimationFrame(scrollHandler);
        };
        img.onload = function () {
          _this2.getParams();
          _this2.setState({
            bgPosition: window.innerHeight - BACKGROUND_MAX_HEIGHT
          });
          window.addEventListener('scroll', _this2.scrollHandler);
          window.addEventListener('resize', _this2.resizeHandler);
        };
        img.src = this.props.context.mobBackgroundImageUrl || this.props.context.backgroundImageUrl;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        _this$props$context = _this$props.context,
        annotation = _this$props$context.annotation,
        url = _this$props$context.url,
        label = _this$props$context.label,
        mortgageWarning = _this$props$context.mortgageWarning,
        mortgageTermsWarning = _this$props$context.mortgageTermsWarning,
        height = _this$props.height,
        width = _this$props.width,
        deviceType = _this$props.deviceType;
      return /*#__PURE__*/_jsxs("a", {
        className: style['link-container'],
        style: getCompleteSizes({
          height: height,
          width: width
        }),
        "data-name": "ParallaxGeneralTemplate",
        href: url,
        target: "_blank",
        rel: "noreferrer noopener nofollow",
        children: [/*#__PURE__*/_jsxs("div", {
          className: style['container'],
          ref: function ref(container) {
            return _this3.container = container;
          },
          children: [/*#__PURE__*/_jsx("div", {
            ref: function ref(animatedBg) {
              return _this3.animatedBg = animatedBg;
            },
            className: style['background'],
            style: {
              backgroundImage: this.backgroundImageUrl
            }
          }), /*#__PURE__*/_jsx("div", {
            className: style['image'],
            style: {
              backgroundImage: this.textImageUrl
            }
          }), annotation && /*#__PURE__*/_jsx("div", {
            className: style['annotation'],
            children: /*#__PURE__*/_jsx(Ticker, {
              text: annotation,
              withBackground: true
            })
          }), label && /*#__PURE__*/_jsx("span", {
            className: style['label'],
            children: label
          })]
        }), (mortgageWarning || mortgageTermsWarning) && /*#__PURE__*/_jsx("div", {
          className: style['mortgage-annotations-wrapper'],
          children: /*#__PURE__*/_jsx(MortgageAnnotations, {
            height: height,
            mortgageWarning: mortgageWarning,
            splitMortgageTermsWarning: deviceType !== 'desktop',
            mortgageTermsWarning: mortgageTermsWarning
          })
        })]
      });
    }
  }, {
    key: "backgroundImageUrl",
    get: function get() {
      var _this$props2 = this.props,
        _this$props2$context = _this$props2.context,
        backgroundImageUrl = _this$props2$context.backgroundImageUrl,
        mobBackgroundImageUrl = _this$props2$context.mobBackgroundImageUrl,
        deviceType = _this$props2.deviceType;
      var imageUrl = deviceType === 'desktop' ? backgroundImageUrl || mobBackgroundImageUrl : mobBackgroundImageUrl || backgroundImageUrl;
      return "url(".concat(imageUrl, ")");
    }
  }, {
    key: "textImageUrl",
    get: function get() {
      var _this$props3 = this.props,
        _this$props3$context = _this$props3.context,
        textImageUrl = _this$props3$context.textImageUrl,
        mobTextImageUrl = _this$props3$context.mobTextImageUrl,
        deviceType = _this$props3.deviceType;
      var imageUrl = deviceType === 'desktop' ? textImageUrl || mobTextImageUrl : mobTextImageUrl || textImageUrl;
      return "url(".concat(imageUrl, ")");
    }
  }, {
    key: "getParams",
    value: function getParams() {
      if (this.container) {
        this.topPosition = this.container.offsetTop - window.innerHeight;
        this.bottomPosition = this.topPosition + this.container.offsetHeight + window.innerHeight;
      }
    }
  }]);
}(React.Component);